import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { locales } from "../../locales";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
};

function UnemploymentRateEvolution({ data, langId }) {
  const labels = data.map((item) => item.year.toString());
  const dataObj = data.map((item) => item.value);

  const chartData = {
    labels,
    datasets: [
      {
        label: locales[langId].unemploymentRate,
        data: dataObj,
        backgroundColor: "#86CDEB",
      },
    ],
  };

  return <Bar options={options} data={chartData} />;
}

export default UnemploymentRateEvolution;
